export default __webpack_public_path__ + "static/Montserrat-MediumItalic-54b24d993e603e7e52c12bbb0bb31d1e.ttf";